/* eslint-disable */
import { produce } from "immer";
import {
  JARGON_FETCH_FAILURE,
  JARGON_FETCH_START,
  JARGON_FETCH_SUCCESS,
} from "../actions/types";

const jargonIllustration = (
  state = {
    jargonIllustrationFetching: false,
    jargonIllustrationData: [],
    jargonIllustrationError: null,
  },
  action,
) => {
  switch (action.type) {
    case JARGON_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case JARGON_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case JARGON_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default jargonIllustration;
